module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_subscript.83949.png";